/**
 * This is global owl carousel onRefreshed listener
 *
 */

var indexHelper = require('../helper/index-helper'),
    toggleArrowsVisibility = require('../toggle-arrows-visibility'),
    pageCounter = require('../customization/page-counter'),
    dots = require('../customization/dots'),
    stagePadding = require('../customization/stage-padding'),
    arrowsControl = require('../customization/arrows-control');

function showHidePageCounter(isPageCounterAvailable, $carousel) {
    if (typeof isPageCounterAvailable !== 'boolean') {
        return;
    }

    if (isPageCounterAvailable) {
        pageCounter.enablePageCounter($carousel);
    } else {
        pageCounter.disablePageCounter($carousel);
    }
}

function showHideDots(isPageDotsAvailable, $carousel) {
    if (typeof isPageDotsAvailable !== 'boolean') {
        return;
    }

    if (isPageDotsAvailable) {
        dots.enableDots($carousel);
    } else {
        dots.disableDots($carousel);
    }
}

function showHideArrows(isPageArrowsAvailable, $carousel) {
    if (typeof isPageArrowsAvailable !== 'boolean') {
        return;
    }

    if (isPageArrowsAvailable) {
        arrowsControl.showArrows($carousel);
    } else {
        arrowsControl.hideArrows($carousel);
    }

}

function setStagePaddingRight(isStagePaddingRightAvailable, $carousel) {
    if (typeof isStagePaddingRightAvailable !== 'boolean') {
        return;
    }

    if (isStagePaddingRightAvailable) {
        stagePadding.removeLeftStagePadding($carousel);
    }
}

module.exports = function subscribeRefreshedEvent($carousels) {
    /**
     * Needed for INITIAL toggle arrows, because only refreshed event knows how much items we have on initial
     * This event does not trigger on carousel changed/dragged/to events, only on carousel breakpoint change (resize)
     */
    $carousels.on('refreshed.owl.carousel', function (event) {
        var $element = $(this);
        var carouselOptions = $element.data('options');
        var currentIndex = indexHelper.getCorrectIndex(event);
        var isPageCounterAvailable,
            isDotsAvailable,
            isArrowsAvailable,
            isStagePaddingRightAvailable;

        if (carouselOptions && !carouselOptions.loop) {
            // From whole number of items count we subtract page size, because currentIndex is page first item index
            toggleArrowsVisibility(
                $element, currentIndex, indexHelper.getCorrectLastIndexFromCarouselEvent(event)
            );
        }

        if (event.relatedTarget && event.relatedTarget.settings) {
            isPageCounterAvailable = event.relatedTarget.settings.pageCounter;
            isDotsAvailable = event.relatedTarget.settings.showDots;
            isArrowsAvailable = event.relatedTarget.settings.showArrows;
            isStagePaddingRightAvailable = event.relatedTarget.settings.stagePaddingRight;
        }
        showHidePageCounter(isPageCounterAvailable, $element);
        showHideDots(isDotsAvailable, $element);
        showHideArrows(isArrowsAvailable, $element);
        setStagePaddingRight(isStagePaddingRightAvailable, $element);
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/events/refreshed.js
// module id = 46
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17